import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const MissionHero = () => {
  return (
    <section className="relative min-h-screen bg-slate-950 flex items-center justify-center overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/10 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/5 rounded-full blur-[120px]"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-8 text-center pt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          <div className="inline-flex items-center space-x-2 bg-white/5 border border-white/10 text-white/80 px-4 py-2 rounded-full text-sm font-medium mb-6 backdrop-blur-md">
            <Icon name="Briefcase" size={14} className="text-primary" />
            <span>Custom Digital Solutions</span>
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-8 leading-[1.1] tracking-tight">
            Crafting Systems{' '}
            <span className="text-gradient bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
              With Integrity
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-slate-400 max-w-4xl mx-auto leading-relaxed mb-12">
            We are a small, skilled startup that builds custom digital solutions for businesses. We prefer honesty 
            and transparency over marketing exaggerations, working closely with every client to develop billing, 
            inventory, bookings, and automation tools that fit their exact business needs.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <div className="flex items-center space-x-2 px-4 py-2 bg-white/5 border border-white/10 rounded-xl text-xs font-bold text-white/50 uppercase tracking-widest">
              <Icon name="ShieldCheck" size={14} className="text-emerald-500" />
              <span>Direct Developer Collaboration</span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 bg-white/5 border border-white/10 rounded-xl text-xs font-bold text-white/50 uppercase tracking-widest">
              <Icon name="Server" size={14} className="text-blue-500" />
              <span>Tailored Database Systems</span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 bg-white/5 border border-white/10 rounded-xl text-xs font-bold text-white/50 uppercase tracking-widest">
              <Icon name="Cpu" size={14} className="text-purple-500" />
              <span>Zero bloated software</span>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-24"
        >
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-10 text-left hover:bg-white/10 transition-all group">
            <div className="w-12 h-12 bg-blue-500/20 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform">
              <Icon name="Code" size={24} className="text-blue-400" />
            </div>
            <h3 className="text-lg font-bold text-white mb-4">Custom Management Systems</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              We design lightweight dashboards, billing applications, and CRMs built strictly to optimize your business operations.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-10 text-left hover:bg-white/10 transition-all group">
            <div className="w-12 h-12 bg-purple-500/20 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform">
              <Icon name="Globe" size={24} className="text-purple-400" />
            </div>
            <h3 className="text-lg font-bold text-white mb-4">Websites & Local SEO</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              Clean marketing websites, catalog setups, and search engine optimizations to ensure local prospects discover you.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-10 text-left hover:bg-white/10 transition-all group">
            <div className="w-12 h-12 bg-emerald-500/20 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform">
              <Icon name="Smartphone" size={24} className="text-emerald-400" />
            </div>
            <h3 className="text-lg font-bold text-white mb-4">Mobile & Automation</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              High-performance mobile layouts and WhatsApp alert integrations to streamline checkouts, bookings, and alerts.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MissionHero;
